import { render, staticRenderFns } from "./ObjetiveForm.vue?vue&type=template&id=4f3f7166"
import script from "./ObjetiveForm.vue?vue&type=script&lang=js"
export * from "./ObjetiveForm.vue?vue&type=script&lang=js"
import style0 from "./ObjetiveForm.vue?vue&type=style&index=0&id=4f3f7166&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports